import { render } from "./BaseFile.vue?vue&type=template&id=41f3b957&scoped=true"
import script from "./BaseFile.vue?vue&type=script&lang=js"
export * from "./BaseFile.vue?vue&type=script&lang=js"

import "./BaseFile.vue?vue&type=style&index=0&id=41f3b957&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f3b957"]])

export default __exports__